export const CUSTOMER_ROLE = 0;
export const SUPPLIER_ROLE = 1;

export const horizontalMenuItems = [
    
    ///////////////////
    // Customer Menu 

    {
        id: 1,
        label: 'Accueil',
        withIcon: false,
        subItems:[],
        link: '/',
        role:CUSTOMER_ROLE
    },
    
    {
        id: 9,
        label: 'Shop',
        subItems:[],
        role:CUSTOMER_ROLE
    },

    {
        id: 2,
        label: 'Carte cadeau',
        link: '/cadeau',
        icon: 'gift.svg',
        role:CUSTOMER_ROLE,
    },

    {
        id: 10,
        label: 'News & Actu',
        link: '/actualites',
        subItems:[],
        icon: 'news.svg',
        role:CUSTOMER_ROLE
    },

    ///////////////////
    // Supplier Menu 
    
    /*{
        id: 100,
        label: 'Accueil',
        subItems:[],
        link: '/',
        role:SUPPLIER_ROLE
    },


    {
        id: 101,
        label: 'Carte cadeau',
        link: '/cadeau',
        role:SUPPLIER_ROLE,
    },

    {
        id: 102,
        label: 'Shop',
        link: '/commandes',
        role:SUPPLIER_ROLE,

    },

    {
        id: 103,
        label: 'News & Actu',
        link:'/actualites',
        role:SUPPLIER_ROLE

    }, */
];

